import { COMPONENTS, EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';

export default function removeViews(game) {
	//REMOVE VIEWS ON ERRORS
	const views = [
		COMPONENTS.LOGO,
		COMPONENTS.INFO_BUTTONS,
		COMPONENTS.STATUS_BAR,
		COMPONENTS.SPIN_BUTTONS,
		COMPONENTS.BET_AMOUNT,
		COMPONENTS.QUEST_WIDGET,
		COMPONENTS.BONUS_BUY_WIDGET,
		COMPONENTS.DOUBLE_CHANCE_WIDGET,
		COMPONENTS.REEL,
		COMPONENTS.WIN_AMOUNT,
		COMPONENTS.WIN_INFO,
		COMPONENTS.STATUS_BAR_BG,
		COMPONENTS.FREESPIN_STATUS_BAR,
		COMPONENTS.QUEST_STATUS_BAR,
		COMPONENTS.BONUS_GAME,
		COMPONENTS.NOTIFICATION,
		COMPONENTS.BONUS_GAME_DIALOGUE,
		COMPONENTS.BONUS_GAME_FINISHED_DIALOGUE,
		COMPONENTS.FREESPIN_PROMPT,
		COMPONENTS.PROMPT,
		COMPONENTS.QUEST_PROMPT,
		COMPONENTS.QUEST_STATUS_BAR,
		COMPONENTS.FREESPIN_STATUS_BAR,
		COMPONENTS.FREE_SPIN_WIN,
		COMPONENTS.FREESPIN_PROMPT,
		COMPONENTS.QUEST_PAGE_CLAIM
	];
	if (GameConfigs.modal !== '') {
		HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
	}
	for (let i = 0; i < views.length; i++) {
		if (GameConfigs.uiComponent[views[i]]) {
			GameConfigs.uiComponent[views[i]].alpha = 0;
		}
	}
	if (game.splash) {
		game.splash.alpha = 0;
		game.splash.removeChild(game.splash);
		delete game.splash;
	}
}
